module.exports = __webpack_public_path__ + "img/line_chart.d8899681.svg";